import React from 'react';
import {
  Route,
  RouteProps,
  Switch,
  useRouteMatch,
} from 'react-router-dom';

import { TermsOfUse } from '@/screens/Policy';

const PolicyRoutes: React.FC<RouteProps> = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/terms`} component={TermsOfUse} />
    </Switch>
  );
};

export default PolicyRoutes;
